<template>
  <div>
    <el-col :span="8">
      <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
        <el-upload
          ref="upload"
          :action="uploadimg.uploadurl"
          :data="uploadimg.uploaddata"
          :headers="uploadimg.headers"
          list-type="picture-card"
          :on-success="uploadsuccess"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :auto-upload="false"
          :file-list="uploadimg.fileList"
          :limit="1"
          :on-change="onchange"
          name="uploadFile"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-tooltip>
    </el-col>
    <el-col :span="8">
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
    </el-col>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="图片展开" />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  name: "SingleImageUpload",
  props: {
    uploadimg: {
      type: Object,
      default: () => {
        return {
          uploadurl:
             process.env.VUE_APP_BASE_API +
        "/api/produce/fileuploader/uploadimg",
          resimg: null,
          uploaddata: {
            folder:"xyqtest"
          },
          headers:{Token:getToken()},
          fileList: [],
        };
      },
    },
  },
  data() {
    return {
      // 上传图片
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  methods: {
    //文件上传
    submitUpload() {},
    // upload
    handleRemove(file, fileList) {
      console.log("file=", file);
      console.log("fileList=", this.fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange(file) {
      console.log("file=", file);
      console.log("fileList=", this.fileList);
    },

    change(val) {},
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadsuccess(response, file, fileList) {
      //  图片上传成功后获取图片地址再提交
      
      console.log(response.data);
      this.uploadimg.resimg = response.data;
      return response.data;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
